module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-02-m-en.79d77a876f2262ffc652e24d6c50d08b.png";